import styles from './index.less';
// import { Arrow, EyeO } from '@react-vant/icons';
import { useEffect, useState } from 'react';
import NoData from '@/components/NoData';
import { detailWechatNotice } from '@/service/banner';
import { Helmet, useLocation } from '@umijs/max';
import { Card, Image } from 'react-vant';
import dayjs from 'dayjs';

interface WechatNoticeDataType {
  communityId?: string;
  communityName?: string;
  content?: string;
  createBy?: string;
  createTime?: string;
  image?: string;
  publishTime?: string;
  sequenceNbr?: string;
  status?: string;
  title?: string;
  topFlag?: string;
  updateBy?: string;
  updateTime?: string;
  urlPath?: string;
  viewCount?: number;
  statusFormatName?: string;
  startTime?: string,
  endTime?: string,
  description?: string,
}
const InfoDetail = () => {
  console.log(useLocation());
  const location = useLocation();
  const data = new URLSearchParams(location.search).get('sequenceNbr');

  const [WechatNoticeData, setWechatNoticeData] =
    useState<WechatNoticeDataType>({});
  useEffect(() => {
    detailWechatNotice({ sequenceNbr: data }).then((res) => {
      console.log(res);
      if (res && res.code === 200 && res.data) {
        const data = res.data;
        setWechatNoticeData(data);
        console.log(33, data);
      } else {
        setWechatNoticeData({});
      }
    });
  }, [data]);

  const formatTime = (time: any) => {
    return time ? dayjs(time).format('YYYY-MM-DD'): '-'
  }

  return (
    <div className={styles['infoDetail']}>
      <Helmet>
        <title>公示信息详情</title>
      </Helmet>
      <div>
        {Object.entries(WechatNoticeData).length ? (
          <>
            <div className={styles['NewsDatailsBox']}>
              {WechatNoticeData.title && (
                <div className={styles.title}>{WechatNoticeData.title}</div>
              )}
              <div className={styles.timeBox}>
                <div className={styles.time}>
                  发布于{WechatNoticeData.publishTime}
                </div>
                <div className={styles.time}>
                  {WechatNoticeData.viewCount}浏览
                </div>
              </div>

              {WechatNoticeData.description && (
                <div className={styles.CardBox}>
                  <Card round>
                    <Card.Body >
                    <strong>简介:</strong>{WechatNoticeData.description}
                  </Card.Body>
                  </Card>
                </div>
              )}
              
              
              
                  {WechatNoticeData.content && (
                    
                    <div className={styles.CardBox}>
                      <Card round>
                        <Card.Header border>内容</Card.Header>
                        <Card.Body>
                      <div
                        className={styles.content}
                        dangerouslySetInnerHTML={{
                          __html: WechatNoticeData.content,
                        }}
                      ></div>
                      </Card.Body>
                      </Card>
                      </div>
                  )}
                
             
            </div>
          </>
        ) : (
          <NoData />
        )}
      </div>
    </div>
  );
};

export default InfoDetail;
